module.exports = __webpack_public_path__ + "static/media/voxwizard-1.8d6b4999.jpg";